import * as types from '../../reduxStore/types/orders';

export const updateOrderFromNotification = (orderDetails) => {
    return {
        type: types.UPDATE_ORDER_FROM_NOTIFICATION,
        payload: orderDetails,
    };
};
